import React from "react";
import { abrirArchivoSeguro } from "./upload";
import { TEMA, tarjetaTema, thTema, tituloSeccionTema } from "../components/TemaDetalle";

// Piezas compartidas por las tres pantallas de Pagos: la bandeja (Pagos),
// Gestionar pago y Registrar pago.

export const FASES_PAGO = {
  por_pagar: { texto: "Por pagar", icono: "⏳", color: "#9c7a1a", bg: "#f3ecd0" },
  en_proceso: { texto: "En proceso", icono: "🔄", color: "#1d5fa8", bg: "#d7e8f7" },
  procesado: { texto: "Procesado", icono: "✓", color: "#2f7a54", bg: "#dcf0e6" },
};

// Facturas a crédito (30 días desde que se recibe el producto con su factura).
export const FASES_CREDITO = {
  esperando_recepcion: { texto: "Esperando recepción", icono: "📦", color: "#5b6472", bg: "#eef1f3" },
  por_pagar: { texto: "Por pagar", icono: "⏳", color: "#9c7a1a", bg: "#f3ecd0" },
  vencido: { texto: "Vencido", icono: "⚠️", color: "#a3402f", bg: "#f7ded9" },
  pagado: { texto: "Pagado", icono: "✓", color: "#2f7a54", bg: "#dcf0e6" },
};

export function BadgeCredito({ fase }) {
  const f = FASES_CREDITO[fase] || FASES_CREDITO.por_pagar;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.3rem",
        padding: "0.2rem 0.65rem",
        borderRadius: 999,
        fontSize: "0.76rem",
        fontWeight: 700,
        color: f.color,
        background: f.bg,
        whiteSpace: "nowrap",
      }}
    >
      <span aria-hidden="true">{f.icono}</span>
      {f.texto}
    </span>
  );
}

// "2026-11-15" -> "15/11/2026"
export const fechaCorta = (iso) => (iso ? String(iso).split("-").reverse().join("/") : "—");

// Cuánto falta (o cuánto lleva vencida) una factura a crédito.
export function textoPlazo(c) {
  if (c.estado === "pagado") return "";
  if (!c.vence_en) return "El plazo empieza al recibir el producto";
  const d = Number(c.dias_restantes);
  if (d < 0) return `Venció hace ${-d} día${d === -1 ? "" : "s"}`;
  if (d === 0) return "Vence hoy";
  return `Faltan ${d} día${d === 1 ? "" : "s"}`;
}

// Bancos con los que se paga (por ahora estos tres; se amplía aquí).
export const BANCOS_PAGO = ["BAC", "La Fise", "Bampro"];

// Formas con las que Contabilidad puede pagar (el crédito no genera pago).
export const METODOS_PAGO = [
  { valor: "efectivo", texto: "Efectivo", icono: "💵" },
  { valor: "cheque", texto: "Cheque", icono: "🧾" },
  { valor: "transferencia", texto: "Transferencia", icono: "🏦" },
  { valor: "tarjeta", texto: "Tarjeta", icono: "💳" },
];

export const nombreMetodo = (valor) => {
  const m = METODOS_PAGO.find((x) => x.valor === valor);
  return m ? `${m.icono} ${m.texto}` : valor || "—";
};

export const COLOR_METODO = {
  cheque: "#3d5a99",
  efectivo: "#9c7a1a",
  transferencia: "#0f7c8a",
  tarjeta: "#7a4a9c",
};

const PALETA_AVATAR = ["#3d5a99", "var(--tema-primario, #2f6690)", "#2f7a54", "#b8722a", "#a3402f", "#0f7c8a"];

export function colorAvatar(nombre) {
  if (!nombre) return PALETA_AVATAR[0];
  let hash = 0;
  for (let i = 0; i < nombre.length; i++) hash = nombre.charCodeAt(i) + ((hash << 5) - hash);
  return PALETA_AVATAR[Math.abs(hash) % PALETA_AVATAR.length];
}

// Documentos que Compras dejó listos antes de enviar el pago a Pagos.
export function DocumentosRespaldo({ datos }) {
  if (!datos || !datos.solicitud_pago_ok) return null;
  const fila = (ok, etiqueta, detalle, archivo) => (
    <div style={{ display: "flex", gap: "0.5rem", alignItems: "baseline", flexWrap: "wrap", padding: "0.25rem 0" }}>
      <span style={{ color: ok ? "#2f7a54" : "#a3402f", fontWeight: 700 }}>{ok ? "✓" : "✕"}</span>
      <strong style={{ color: "var(--tema-titulo, #0b3c60)", fontSize: "0.85rem" }}>{etiqueta}</strong>
      {detalle && <span style={{ color: "#5b6472", fontSize: "0.82rem" }}>{detalle}</span>}
      {archivo && (
        <a href="#" onClick={(e) => abrirArchivoSeguro(e, archivo)} style={{ color: "var(--tema-primario, #2f6690)", fontWeight: 600, fontSize: "0.82rem" }}>
          📎 Ver archivo
        </a>
      )}
    </div>
  );
  return (
    <div style={{ background: "#fff", border: "1px solid #e2e6ea", borderRadius: 14, padding: "1.1rem 1.3rem", marginTop: "1rem", boxShadow: "0 1px 3px rgba(27,42,74,0.06)", ...tarjetaTema }}>
      <div style={{ ...tituloSeccionTema, marginBottom: "0.5rem" }}>
        Documentos de respaldo (Compras)
      </div>
      {fila(true, "Solicitud de pago autorizada", datos.solicitud_pago_numero ? `N.º ${datos.solicitud_pago_numero}` : "", datos.solicitud_pago_archivo)}
      {fila(!!datos.otros_docs_ok, "Otros documentos", datos.otros_docs_nota, datos.otros_docs_archivo)}
      {datos.docs_listos_por_nombre && (
        <div style={{ color: "#8993a1", fontSize: "0.75rem", marginTop: "0.3rem" }}>
          Marcados por {datos.docs_listos_por_nombre}
          {datos.docs_listos_en ? ` el ${new Date(datos.docs_listos_en).toLocaleDateString("es-NI")}` : ""}
        </div>
      )}
    </div>
  );
}

export const numItem = (n) => String(n).padStart(2, "0");
export const folioPago = (id) => `#${String(id).padStart(3, "0")}`;

// Monto en córdobas (las cotizaciones en dólares se convierten con su propio
// tipo de cambio) — para sumar totales sin mezclar monedas.
export function montoEnNioPago(p) {
  const monto = Number(p.monto_total);
  return p.moneda === "USD" ? monto * Number(p.tipo_cambio || 0) : monto;
}

export function formatoCordobas(n) {
  return `C$${n.toLocaleString("es-NI", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// El monto se muestra en la moneda de la cotización, sin equivalente en otra moneda.
export function montoTextoPago(p) {
  const simbolo = p.moneda === "USD" ? "US$" : "C$";
  return `${simbolo}${Number(p.monto_total).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Neto a pagar (monto menos retenciones) en la moneda de la cotización; null si el proveedor no tiene retenciones.
export function netoTextoPago(p) {
  if (!p.retenciones || p.retenciones.length === 0 || p.neto_pagar == null) return null;
  const simbolo = p.moneda === "USD" ? "US$" : "C$";
  return `${simbolo}${Number(p.neto_pagar).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Monto de la factura y, si hay retenciones, debajo el neto que se le paga al proveedor.
export function MontoConNeto({ pago }) {
  const neto = netoTextoPago(pago);
  return (
    <>
      <strong>{montoTextoPago(pago)}</strong>
      {neto && <div style={{ fontSize: "0.78rem", color: "#2f7a54", fontWeight: 600 }}>Neto a pagar: {neto}</div>}
    </>
  );
}

export function textoArticulos(items) {
  const n = (items || []).length;
  return `${n} artículo${n === 1 ? "" : "s"}`;
}

export function BadgeFase({ fase }) {
  const f = FASES_PAGO[fase] || FASES_PAGO.por_pagar;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.3rem",
        padding: "0.2rem 0.65rem",
        borderRadius: 999,
        fontSize: "0.76rem",
        fontWeight: 700,
        color: f.color,
        background: f.bg,
        whiteSpace: "nowrap",
      }}
    >
      <span aria-hidden="true">{f.icono}</span>
      {f.texto}
    </span>
  );
}

// Tabla Ítem / Producto / Precio unitario / Cantidad aprobada.
export function TablaItemsPago({ items, moneda }) {
  const simbolo = moneda === "USD" ? "US$" : "C$";
  return (
    <div className="table-scroll" style={estilos.tablaItemsWrap}>
      <table style={estilos.tablaItems}>
        <thead>
          <tr>
            <th style={estilos.thItems}>Ítem</th>
            <th style={estilos.thItems}>Producto</th>
            <th style={{ ...estilos.thItems, textAlign: "right" }}>Precio unitario</th>
            <th style={{ ...estilos.thItems, textAlign: "right" }}>Cantidad aprobada</th>
          </tr>
        </thead>
        <tbody>
          {(items || []).map((it) => (
            <tr key={it.numero_item}>
              <td style={estilos.tdItems}>
                <span style={estilos.chipItem}>{numItem(it.numero_item)}</span>
              </td>
              <td style={estilos.tdItems}>{it.descripcion}</td>
              <td style={{ ...estilos.tdItems, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                {it.precio_unitario != null ? `${simbolo}${it.precio_unitario.toFixed(2)}` : "—"}
              </td>
              <td style={{ ...estilos.tdItems, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                {it.cantidad}
                {it.unidad ? ` ${it.unidad}` : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Subtotal, IVA (si la factura lo lleva) y total, uno debajo del otro y
// alineados a la derecha, para ponerlo debajo de la tabla de productos.
export function DesglosePago({ pago }) {
  if (pago.subtotal == null) return null;
  const simbolo = pago.moneda === "USD" ? "US$" : "C$";
  const dinero = (n) =>
    `${simbolo}${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const retenciones = pago.retenciones || [];
  // Cada impuesto aparece solo si se le cobra al proveedor: Subtotal y Total siempre; IVA solo si paga IVA;
  // retenciones y neto solo si tiene retenciones marcadas.
  return (
    <div style={estilos.desglose}>
      <div style={estilos.linea}>
        <span>Subtotal</span>
        <span>{dinero(pago.subtotal)}</span>
      </div>
      {!pago.exento_iva && (
        <div style={estilos.linea}>
          <span>{`IVA ${Number(pago.iva_porcentaje ?? 15)}%`}</span>
          <span>{dinero(pago.iva)}</span>
        </div>
      )}
      <div style={{ ...estilos.linea, ...(retenciones.length === 0 ? estilos.lineaTotal : null) }}>
        <span>Total</span>
        <span>{dinero(pago.total)}</span>
      </div>
      {retenciones.map((r) => (
        <div key={r.nombre} style={estilos.linea}>
          <span>
            (−) Retención {r.nombre} {r.porcentaje}% <span style={estilos.equivalente}>del subtotal</span>
          </span>
          <span>−{dinero(r.monto)}</span>
        </div>
      ))}
      {retenciones.length > 0 && (
        <div style={{ ...estilos.linea, ...estilos.lineaTotal }}>
          <span>Neto a pagar</span>
          <span>{dinero(pago.neto_pagar)}</span>
        </div>
      )}
    </div>
  );
}

const estilos = {
  desglose: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "0.2rem",
    width: "fit-content",
    maxWidth: "100%",
    margin: "0.8rem 0 0 auto",
    padding: "0.7rem 0.95rem",
    background: TEMA.azulSuave,
    border: `1px solid ${TEMA.linea}`,
    borderRadius: 10,
    fontSize: "0.88rem",
    color: "#5b6472",
    fontVariantNumeric: "tabular-nums",
  },
  linea: { display: "flex", justifyContent: "space-between", gap: "2rem", minWidth: 250 },
  lineaTotal: {
    marginTop: "0.25rem",
    paddingTop: "0.4rem",
    borderTop: `2px solid ${TEMA.azul}`,
    fontSize: "1.08rem",
    fontWeight: 800,
    color: TEMA.azulOscuro,
  },
  equivalente: { fontSize: "0.74rem", color: "#8993a1", marginTop: "0.15rem" },
  tablaItemsWrap: { border: "1px solid #e2e6ea", borderRadius: 10, overflow: "hidden" },
  tablaItems: { width: "100%", borderCollapse: "collapse", fontSize: "0.85rem" },
  thItems: {
    textAlign: "left",
    padding: "0.5rem 0.7rem",
    fontSize: "0.72rem",
    whiteSpace: "nowrap",
    ...thTema,
  },
  tdItems: { padding: "0.5rem 0.7rem", color: "var(--tema-titulo, #0b3c60)", borderTop: "1px solid #eef1f3" },
  chipItem: {
    fontSize: "0.68rem",
    fontWeight: 700,
    color: "#0f7c8a",
    background: "#d5eef1",
    borderRadius: 999,
    padding: "0.1rem 0.5rem",
    whiteSpace: "nowrap",
  },
};
